import React, { useState, useEffect } from "react";
import DashboardHeader from '../../Header/DashboardHeader';
import DashboardFooter from '../../Footer/DashboardFooter';
import DashboardLeftMenu from '../DashboardLeftMenu';
import WhatsappPricing from './WhatsappPricing';
import StaticPricingCards from './StaticPricingCards';
import styles from "./PricingDetails.module.css";
import Axios from "axios";
import { NODE_HOST_URL_v1, userProfile } from "../api/Api";
import { FiCheck, FiAlertTriangle } from "react-icons/fi";

const TABS = [
  {
    key: "channel",
    label: "Channel Pricing",
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.65 3.4 2 2 0 0 1 3.62 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.69a16 16 0 0 0 6 6l.86-.86a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16z" />
      </svg>
    ),
  },
  {
    key: "plans",
    label: "Add On",
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" />
        <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
        <line x1="12" y1="12" x2="12" y2="16" />
        <line x1="10" y1="14" x2="14" y2="14" />
      </svg>
    ),
  },
];

const TAB_META = {
  channel: { heading: "Channel Pricing",  sub: "Per-conversation rates across all messaging channels." },
  plans:   { heading: "Add On",           sub: "Enhance your experience with powerful plans." },
};

const ACCENT = "#6366f1";

const PricingDetails = () => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  const calendly_link = lStorage?.user?.calendy_link;

  const countryCurrency = lStorage?.user?.country_currency || "USD";
  const CURRENCY_CONFIG = {
    INR: { symbol: "₹", key: "amount_inr" },
    USD: { symbol: "$", key: "amount_usd" },
    EUR: { symbol: "€", key: "amount_eur" },
  };
  const currency = CURRENCY_CONFIG[countryCurrency] || CURRENCY_CONFIG.USD;

  const [activeTab, setActiveTab] = useState("channel");
  const [allPlans, setAllPlans] = useState([]);
  const [userActivePlans, setUserActivePlans] = useState([]);
  const [plansLoading, setPlansLoading] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showPaymentConfirm, setShowPaymentConfirm] = useState(false);
  const [showInsufficientBalance, setShowInsufficientBalance] = useState(false);
  const [showFinalConfirm, setShowFinalConfirm] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [autoRenew, setAutoRenew] = useState(false);
  const [userBalance , setUserBalance] = useState("");
  const [alert, setAlert] = useState({ show: false, message: "", bgColor: "" });

  const meta = TAB_META[activeTab];
  const addOnPlans = allPlans.filter((p) => p.plan_type !== "main_plan");

  useEffect(() => {
    fetchAllPlans();
    fetchUserActivePlans();
    fetchUserProfileData();
  }, []);

  useEffect(() => {
    if (activeTab === "plans") {
      fetchUserActivePlans();
    }
  }, [activeTab]);

  const fetchAllPlans = async () => {
    setPlansLoading(true);
    try {
      const response = await Axios.post(`${NODE_HOST_URL_v1}/plans`, {
        method: "fetchPlans",
        user_id: userId,
        token: userToken,
      });
      if (response.data.success === true) {
        setAllPlans((response.data.data || []).filter((p) => p.status === 1));
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
    setPlansLoading(false);
  };

  const fetchUserProfileData = async () => {
    try {
      const { data } = await userProfile({
        method: "retrieve",
        token: userToken,
        user_id: userId,
      });
      if (data.success === true) {
        // console.log(data.data);
        setUserBalance(data?.data[0]?.currency)
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  // console.log(userBalance);
  

  const fetchUserActivePlans = async () => {
    try {
      const response = await Axios.post(`${NODE_HOST_URL_v1}/plans`, {
        method: "fetchUserEnabledPlans",
        user_id: userId,
        token: userToken,
      });
      if (response.data.success === true) {
        setUserActivePlans(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching user plans:", error);
    }
  };

  const handleBuyNowClick = (plan) => {
    const planAmount = Number(plan[currency.key] || 0);
    if (Number(userBalance || 0) < planAmount) {
      setShowInsufficientBalance(true);
      return;
    }
    setSelectedPlan(plan);
    setShowPaymentConfirm(true);
  };

  const handleStaticCardBuy = (planTitle) => {
    const plan = allPlans.find((p) => p.plan_title === planTitle);
    if (plan) {
      handleBuyNowClick(plan);
    }
  };

  const handlePayment = async () => {
    setPaymentLoading(true);
    try {
      const res = await Axios.post(`${NODE_HOST_URL_v1}/plans`, {
        user_id: userId,
        token: userToken,
        method: "widgetPlan",
        planId: selectedPlan.id,
        payment_method: "wallet",
        amount: parseFloat(selectedPlan[currency.key]),
        duration: selectedPlan.plan_duration,
        auto_renew: autoRenew ? 1 : 0,
      });
      setShowFinalConfirm(false);
      setAlert({
        show: true,
        message: res.data.message || (res.data.success ? "Payment successful!" : "Payment failed."),
        bgColor: res.data.success ? "alert alert-success alert-dismissible" : "alert alert-danger alert-dismissible",
      });
      if (res.data.success) {
        fetchUserActivePlans();
      }
    } catch (error) {
      setShowFinalConfirm(false);
      setAlert({
        show: true,
        message: error?.response?.data?.message || "Something went wrong.",
        bgColor: "alert alert-danger alert-dismissible",
      });
    }
    setPaymentLoading(false);
  };

  return (
    <div className="wrapper">
      <DashboardLeftMenu />
      <div className="main">
        <DashboardHeader />
        <main className="content">
          <div className="container-fluid p-0">
            <StaticPricingCards countryCurrency={countryCurrency} onBuyPlan={handleStaticCardBuy} userActivePlans={userActivePlans} />

            {/* ── Toggle bar ── */}
            <div className={styles.toggleWrapper}>
              <div className={styles.toggleTrack}>
                {TABS.map((tab) => (
                  <button
                    key={tab.key}
                    className={`${styles.toggleBtn} ${activeTab === tab.key ? styles.toggleActive : ""}`}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    <span className={styles.tabIcon}>{tab.icon}</span>
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            {/* ── Section intro ── */}
            <div className={styles.sectionIntro}>
              <h5 className={styles.sectionHeading}>{meta.heading}</h5>
              <p className={styles.sectionSub}>{meta.sub}</p>
            </div>

            {alert.show && (
              <div className={`${alert.bgColor} mx-3`} role="alert">
                <button type="button" className="close" onClick={() => setAlert({ show: false, message: "", bgColor: "" })}>
                  <span aria-hidden="true">×</span>
                </button>
                {alert.message}
              </div>
            )}

            {/* ── Channel Pricing ── */}
            {activeTab === "channel" && (
              <>
                <WhatsappPricing />
                <p className={styles.footerNote}>
                  Note: Prices shown are per conversation, valid for 24-hour windows.
                </p>
                {calendly_link && (
                  <div className="container-fluid px-3">
                    <div className={styles.cardContainer}>
                      <p className={styles.cardText}>
                        For monthly volumes above 1 Lakh, connect with us for custom pricing.
                      </p>
                      <button className={styles.cardButton}
                        onClick={() => window.open(calendly_link, "_blank")}>
                        Connect for Discount
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}

            {/* ── Plans ── */}
            {activeTab === "plans" && (
              <div className={`container-fluid px-3 ${styles.plansSection}`}>
                {plansLoading ? (
                  <div className={styles.plansEmptyState}>Loading plans…</div>
                ) : addOnPlans.length === 0 ? (
                  <div className={styles.plansEmptyState}>No plans available.</div>
                ) : (
                  <div className={styles.planGrid}>
                    {addOnPlans.map((plan) => {
                      const lines = (plan.plan_description || "").split(/\r?\n/).map(l => l.trim()).filter(Boolean);
                      const desc = lines[0] || "";
                      const features = lines.slice(1);
                      const matchedPlan = userActivePlans.find((p) => {
                        if (p.plan_title === plan.plan_title) return true;
                        if (p.add_on && typeof p.add_on === "object") {
                          return Object.keys(p.add_on).includes(plan.plan_title);
                        }
                        return false;
                      });
                      const isExpired = !!matchedPlan && !!matchedPlan.is_expired;
                      const isActive = !!matchedPlan && !isExpired;
                      return (
                        <div key={plan.id} className={styles.planCard}>
                          <div className={styles.planAccentBar} />
                          <div className={styles.planCardBody}>
                            {(plan.plan_for || plan.plan_type) && (
                              <span className={styles.planBadge}>
                                {plan.plan_for || plan.plan_type}
                              </span>
                            )}
                            <div className={styles.planCardTitle}>{plan.plan_title}</div>
                            {desc && <div className={styles.planCardDesc}>{desc}</div>}
                            {features.length > 0 && (
                              <ul className={styles.planFeatures}>
                                {features.map(f => (
                                  <li key={f} className={styles.planFeature}>
                                    <FiCheck size={12} style={{ flexShrink: 0 }} />
                                    <span>{f}</span>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                          <div className={styles.planCardFooter}>
                            <div className={styles.planPriceBlock}>
                              <span className={styles.planPrice}>{currency.symbol}{plan[currency.key]}</span>
                              <span className={styles.planPriceSub}>/{plan.plan_duration}</span>
                            </div>
                            {isActive ? (
                              <span className={styles.planActiveBadge}><FiCheck size={11} /> Active</span>
                            ) : isExpired ? (
                              <div className={styles.planFooterActions}>
                                <span className={styles.planExpiredBadge}>Expired</span>
                                <button
                                  type="button"
                                  className={`${styles.planCtaBtn} ${styles.planRenewBtn}`}
                                  onClick={() => handleBuyNowClick(plan)}
                                >
                                  Renew Plan
                                </button>
                              </div>
                            ) : (
                              <button
                                type="button"
                                className={styles.planCtaBtn}
                                onClick={() => handleBuyNowClick(plan)}
                              >
                                Buy Now
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

          </div>
        </main>

        <DashboardFooter />
      </div>

      {/* ── Payment Confirm Modal ── */}
      {showPaymentConfirm && selectedPlan && (
        <div className={styles.modalBackdrop} onClick={() => setShowPaymentConfirm(false)}>
          <div className={styles.modalCard} onClick={(e) => e.stopPropagation()}>
            <button className={styles.modalCloseBtn} onClick={() => setShowPaymentConfirm(false)}>✕</button>
            <div className={styles.modalTopStrip}>
              <div className={styles.modalHeaderTitle}>Choose Payment</div>
              <div className={styles.modalHeaderSub}>Complete your purchase securely</div>
            </div>
            <div className={styles.modalBody}>
              <div className={styles.modalPlanRow}>
                <div>
                  <div className={styles.modalPlanName}>{selectedPlan.plan_title}</div>
                  <div className={styles.modalPlanDuration}>Billed {selectedPlan.plan_duration}</div>
                </div>
                <div className={styles.modalPlanPrice}>{currency.symbol}{selectedPlan[currency.key]}</div>
              </div>
              <div className={styles.modalSectionLabel}>Payment Method</div>
              <div className={styles.modalWalletCard}>
                <div className={styles.modalWalletName}>Wallet</div>
                <span className={styles.modalWalletBadge}>✓ Selected</span>
              </div>
              <div className={styles.modalSectionLabel}>Options</div>
              <div className={styles.modalAutoRenewRow}>
                <div>
                  <div className={styles.modalAutoRenewTitle}>Auto-renew</div>
                  <div className={styles.modalAutoRenewSub}>Automatically renew when plan expires</div>
                </div>
                <label className={styles.modalToggleSwitch}>
                  <input type="checkbox" checked={autoRenew} onChange={(e) => setAutoRenew(e.target.checked)} />
                  <span className={styles.modalToggleSlider}></span>
                </label>
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button className={styles.modalBtnCancel} onClick={() => setShowPaymentConfirm(false)}>Cancel</button>
              <button className={styles.modalBtnConfirm} onClick={() => { setShowPaymentConfirm(false); setShowFinalConfirm(true); }}>Continue →</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Final Confirm Modal ── */}
      {showFinalConfirm && selectedPlan && (
        <div className={styles.modalBackdrop} onClick={() => !paymentLoading && setShowFinalConfirm(false)}>
          <div className={styles.modalCard} onClick={(e) => e.stopPropagation()}>
            {!paymentLoading && <button className={styles.modalCloseBtn} onClick={() => setShowFinalConfirm(false)}>✕</button>}
            <div className={styles.modalTopStrip}>
              <div className={styles.modalHeaderTitle}>Confirm &amp; Pay</div>
              <div className={styles.modalHeaderSub}>Review your order before payment</div>
            </div>
            <div className={styles.modalBody}>
              <div className={styles.modalSectionLabel}>Order Summary</div>
              <div className={styles.modalPlanRow}>
                <div>
                  <div className={styles.modalPlanName}>{selectedPlan.plan_title}</div>
                  <div className={styles.modalPlanDuration}>Billed {selectedPlan.plan_duration}</div>
                </div>
                <div className={styles.modalPlanPrice}>{currency.symbol}{selectedPlan[currency.key]}</div>
              </div>
              <div className={styles.modalDetailsList}>
                <div className={styles.modalDetailRow}>
                  <span className={styles.modalDetailKey}>Plan Duration</span>
                  <span className={styles.modalDetailVal}>{selectedPlan.plan_duration}</span>
                </div>
                <div className={styles.modalDetailRow}>
                  <span className={styles.modalDetailKey}>Payment via</span>
                  <span className={styles.modalDetailVal}>Wallet</span>
                </div>
                <div className={styles.modalDetailRow}>
                  <span className={styles.modalDetailKey}>Auto-renew</span>
                  <span className={`${styles.modalDetailVal} ${autoRenew ? styles.modalDetailValGreen : styles.modalDetailValMuted}`}>
                    {autoRenew ? "Enabled" : "Disabled"}
                  </span>
                </div>
                <div className={`${styles.modalDetailRow} ${styles.modalDetailRowTotal}`}>
                  <span className={styles.modalDetailKey}>Total charged</span>
                  <span className={styles.modalDetailValBold}>{currency.symbol}{selectedPlan[currency.key]}</span>
                </div>
              </div>
              <div className={styles.modalWarningBox}>
                <span>{currency.symbol}{selectedPlan[currency.key]} will be instantly deducted from your wallet. This action cannot be undone.</span>
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button className={styles.modalBtnCancel} onClick={() => { setShowFinalConfirm(false); setShowPaymentConfirm(true); }} disabled={paymentLoading}>← Back</button>
              <button className={styles.modalBtnConfirm} onClick={handlePayment} disabled={paymentLoading}>
                {paymentLoading ? "Processing..." : "Confirm & Pay"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Insufficient Balance Modal ── */}
      {showInsufficientBalance && (
        <div className={styles.modalBackdrop} onClick={() => setShowInsufficientBalance(false)}>
          <div className={styles.modalCard} style={{ maxWidth: "380px" }} onClick={(e) => e.stopPropagation()}>
            <button className={styles.modalCloseBtn} onClick={() => setShowInsufficientBalance(false)}>✕</button>
            <div className={styles.insufficientBody}>
              <div className={styles.insufficientIconWrap}>
                <FiAlertTriangle size={24} />
              </div>
              <div className={styles.insufficientTitle}>Insufficient Balance</div>
              <p className={styles.insufficientMsg}>
                Recharge your wallet to activate the plan.
              </p>
            </div>
            <div className={styles.modalFooter}>
              <button className={styles.modalBtnCancel} onClick={() => setShowInsufficientBalance(false)}>Cancel</button>
              <button
                className={styles.modalBtnConfirm}
                onClick={() => { window.location.href = "/dashboard/transaction-payment"; }}
              >
                Recharge Wallet
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingDetails;
